import React from "react";
import "../../../common/FormFields/FormFields.css";

const LogoUpload = ({ 
  previewUrl, 
  onFileSelect,
  disabled = false,
  audittrail = false
}) => {
  const handleFileInputClick = () => {
    if (disabled) return;
    document.getElementById("company-logo-input")?.click();
  };

  return (
    <div className="form-field logo-field">
      <div className="logo-label">
        <label className="form-field-label">
          Company Logo
          {(!disabled || audittrail) && <span className="form-field-required">*</span>}
        </label>
        {(!disabled || audittrail) && (
          <div className="logo-actions">
            <button
              type="button"
              className="replace-btn"
              onClick={handleFileInputClick}
              disabled={disabled}
            >
              {previewUrl ? "Replace" : "Upload"}
            </button>
          </div>
        )}
      </div>
      <input
        id="company-logo-input"
        type="file"
        accept="image/*"
        onChange={onFileSelect}
        style={{ display: "none" }}
        disabled={disabled}
      />
      <div 
        className={`logo-preview ${disabled ? "logo-preview-disabled" : ""}`}
        onClick={handleFileInputClick}
        style={{ cursor: disabled ? "default" : "pointer", opacity: disabled ? 0.7 : 1 }}
      >
        {previewUrl ? (
          <img
            src={previewUrl}
            alt="Company Logo"
          />
        ) : (
          <div className="logo-placeholder">Upload a company logo</div>
        )}
      </div>
    </div>
  );
};

export default LogoUpload;